/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfClient } from '../models';
// @ts-ignore
import type { BfClientConfig } from '../models';
// @ts-ignore
import type { BfClientTimePeriod } from '../models';
// @ts-ignore
import type { BfMapTimeManifest } from '../models';
/**
 * ConfigApi - axios parameter creator
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch the client config for the given client
         * @summary Client config
         * @param {BfClient} bfClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientConfig: async (bfClient: BfClient, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfClient' is not null or undefined
            assertParamExists('clientConfig', 'bfClient', bfClient)
            const localVarPath = `/v1/config/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfClient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the client config for the requested time period. This will provide layers that were current for the requested time period
         * @summary Map config for time period
         * @param {BfClientTimePeriod} bfClientTimePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapConfigForTimePeriod: async (bfClientTimePeriod: BfClientTimePeriod, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfClientTimePeriod' is not null or undefined
            assertParamExists('mapConfigForTimePeriod', 'bfClientTimePeriod', bfClientTimePeriod)
            const localVarPath = `/v1/config/map/time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfClientTimePeriod, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch the client config for the given client
         * @summary Client config
         * @param {BfClient} bfClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientConfig(bfClient: BfClient, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfClientConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientConfig(bfClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigApi.clientConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the client config for the requested time period. This will provide layers that were current for the requested time period
         * @summary Map config for time period
         * @param {BfClientTimePeriod} bfClientTimePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapConfigForTimePeriod(bfClientTimePeriod: BfClientTimePeriod, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfMapTimeManifest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapConfigForTimePeriod(bfClientTimePeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigApi.mapConfigForTimePeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigApi - factory interface
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigApiFp(configuration)
    return {
        /**
         * Fetch the client config for the given client
         * @summary Client config
         * @param {BfClient} bfClient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientConfig(bfClient: BfClient, options?: RawAxiosRequestConfig): AxiosPromise<BfClientConfig> {
            return localVarFp.clientConfig(bfClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the client config for the requested time period. This will provide layers that were current for the requested time period
         * @summary Map config for time period
         * @param {BfClientTimePeriod} bfClientTimePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapConfigForTimePeriod(bfClientTimePeriod: BfClientTimePeriod, options?: RawAxiosRequestConfig): AxiosPromise<BfMapTimeManifest> {
            return localVarFp.mapConfigForTimePeriod(bfClientTimePeriod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 */
export class ConfigApi extends BaseAPI {
    /**
     * Fetch the client config for the given client
     * @summary Client config
     * @param {BfClient} bfClient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public clientConfig(bfClient: BfClient, options?: RawAxiosRequestConfig) {
        return ConfigApiFp(this.configuration).clientConfig(bfClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the client config for the requested time period. This will provide layers that were current for the requested time period
     * @summary Map config for time period
     * @param {BfClientTimePeriod} bfClientTimePeriod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mapConfigForTimePeriod(bfClientTimePeriod: BfClientTimePeriod, options?: RawAxiosRequestConfig) {
        return ConfigApiFp(this.configuration).mapConfigForTimePeriod(bfClientTimePeriod, options).then((request) => request(this.axios, this.basePath));
    }
}

